import { ComponentId } from "@omegagrid/core";

export type ParsedComponentId = {
	type: string;
	id?: ComponentId;
	ids: string[];
};

export function parseComponentId(id: ComponentId, chunkSeparator = '-'): ParsedComponentId {
	const chunks = (id.toString()).split(new RegExp(`(?<!${chunkSeparator})${chunkSeparator}`));
	return {
		type: chunks[0],
		id: chunks.length > 1 ? chunks[1] : null,
		ids: chunks.length > 1 ? chunks.slice(1) : []
	};
}
